export default "__VITE_ASSET__e208eb05__"